module.exports = __webpack_public_path__ + "images/[12].jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/slider/[12].jpg
// module id = 43
// module chunks = 0